/**
 * withSystemSettings
 * HOC for wrapping the provided component with SystemSettingsProvider
 */

import React from 'react'

import SystemSettingsProvider from './system-settings-provider'

export default function withSystemSettings (WrappedComponent) {
  return function SystemSettingsProviderHOC(props) {
    return (
      <SystemSettingsProvider>
        <WrappedComponent {...props} />
      </SystemSettingsProvider>
    )
  }
}
